import { render, staticRenderFns } from "./offer-similars.vue?vue&type=template&id=610a3f88&scoped=true&"
import script from "./offer-similars.vue?vue&type=script&lang=js&"
export * from "./offer-similars.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "610a3f88",
  null
  ,true
)

export default component.exports